import API from "../../apiConfig";

export const registerUser = async (data) => {
    const response = await API.post("user/v1/seller/update_register_request", data, { withCredentials: false });
    return response;
};

export const fetchCity = async (pincode) => {
    const response = await API.get(`address/pincode_detail?pincode=${pincode}`, null, null, { withCredentials: false });
    return response;
};

export const fetchUserDetails = async (id) => {
    const response = await API.get(`user/v1/seller/register_request?request_id=${id}`, null, null, { withCredentials: false });
    return response;
};